export default class OfferCampaignProductSpec {
  constructor($scope, ProductService) {
    $scope.$watch('spec.product_category_id', function() {
      if ($scope.spec.product_category_id) {
        ProductService.get_groups($scope.spec.product_category_id).then(function(data) {
          $scope.product_groups = data.groups;
        });
      }
    });

    $scope.$watch('spec.product_group_id', function() {
      if ($scope.spec.product_group_id) {
        ProductService.get_products($scope.spec.product_group_id).then(function(data) {
          $scope.products = data.products;
        });
      }
    });

    $scope.init = function() {
      $scope.product_groups = [];
      $scope.products = [];
    };

    $scope.init();
  }
}

OfferCampaignProductSpec.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign-product-spec.ctrl.js